var _ellipse, _path, _path2, _path3, _ellipse2, _path4, _path5, _path6, _ellipse3, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolaPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 116,
    viewBox: "0 0 132 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7216,
    cy: 27.4513,
    rx: 26.7216,
    ry: 27.4513,
    transform: "matrix(0.94693 -0.321439 0.172789 0.984959 3.93774 60.8081)",
    fill: "#292B2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0119 68.0943C58.6028 82.8635 49.498 98.6248 35.6958 103.31C21.8935 107.995 8.59309 99.8395 6.00216 85.0703C3.41123 70.301 12.516 54.5398 26.3182 49.8546C40.1205 45.1694 53.4209 53.325 56.0119 68.0943Z",
    fill: "#FFF0AB",
    stroke: "#292B2E",
    strokeWidth: 0.630843
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2236 100.616C22.8016 104.832 10.8439 97.4903 8.51531 84.2166C6.18675 70.9429 14.3691 56.7642 26.7911 52.5475C39.2131 48.3308 51.1708 55.6729 53.4994 68.9466C54.7435 76.0389 52.987 83.3895 49.1863 89.3409",
    stroke: "#292B2E",
    strokeWidth: 0.630843
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3887 74.8222C32.928 74.2702 35.9983 72.7612 37.7047 70.2586L36.1113 61.1757L39.8818 59.8958L44.0611 83.7197L40.2907 84.9996L38.4997 74.79L38.446 74.4839C37.0271 75.7958 35.2695 76.8101 33.1554 77.5277C31.9062 77.9518 30.5317 78.2718 29.0324 78.4914L30.7427 88.2407L26.9737 89.5201L25.0979 78.8274C24.5759 78.844 24.0433 78.8524 23.4971 78.8501C20.631 78.8387 17.2423 80.4701 15.8674 81.6622L14.489 78.3714C16.5136 76.8368 20.2855 75.0476 23.8701 75.0623C24.0613 75.063 24.2496 75.0619 24.4371 75.0603L22.7944 65.6962L26.5633 64.4169L28.2769 74.1851L28.3887 74.8222Z",
    fill: "#292B2E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4073,
    cy: 20.4413,
    rx: 20.4073,
    ry: 20.4413,
    transform: "matrix(0.996072 -0.0885433 -0.262361 0.96497 54.6819 5.11755)",
    fill: "#292B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7151 19.5182C84.9096 29.837 73.8045 38.9966 62.9017 39.9658C51.999 40.935 45.4479 33.3448 48.2534 23.0261C51.0589 12.7073 62.164 3.5477 73.0668 2.57853C83.9695 1.60936 90.5206 9.19949 87.7151 19.5182Z",
    fill: "#FFF0AB",
    stroke: "#292B2E",
    strokeWidth: 0.549603
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1045 16.5793C57.4023 10.09 65.0403 5.08789 72.5656 4.41895C82.3862 3.54596 88.2961 10.3833 85.7656 19.6905C83.2351 28.9978 73.2225 37.2505 63.4018 38.1235C57.3171 38.6644 52.7337 36.2454 50.7289 32.113C49.855 30.3116 49.4711 28.1845 49.6664 25.8351M49.7431 24.696C49.8135 24.1679 49.9658 22.7179 50.609 21.2585",
    stroke: "#292B2E",
    strokeWidth: 0.549603
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7372 19.6726C70.0186 20.0194 72.591 19.4893 74.5378 18.0743L76.2694 11.7055L79.2502 11.4405L74.7084 28.1454L71.7276 28.4104L73.674 21.2515L73.7323 21.0369C72.3525 21.6958 70.8332 22.1005 69.1618 22.2491C68.1742 22.3369 67.1331 22.3348 66.0377 22.2453L64.1791 29.0814L61.1994 29.3462L63.2378 21.8487C62.8751 21.7772 62.5076 21.6986 62.1342 21.6105C60.1742 21.1491 57.3456 21.7113 56.0332 22.2963L56.1117 19.8621C57.9757 19.1492 61.1158 18.5415 63.567 19.1188C63.6978 19.1496 63.8271 19.1786 63.956 19.2073L65.7412 12.6414L68.7209 12.3765L66.8586 19.2258L66.7372 19.6726Z",
    fill: "#292B2E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.2211,
    cy: 26.9796,
    rx: 26.2211,
    ry: 26.9796,
    transform: "matrix(0.896873 0.442289 -0.646257 0.76312 83.1721 20.4294)",
    fill: "#292B2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.301 60.6788C101.978 71.6873 84.1557 75.5387 71.496 69.2957C58.8364 63.0526 56.1162 49.0707 65.4389 38.0622C74.7616 27.0537 92.5841 23.2023 105.244 29.4453C117.903 35.6884 120.624 49.6703 111.301 60.6788Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.549603
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.529 31.4725C114.907 37.0837 117.345 49.6455 108.974 59.5301C100.603 69.4147 84.5933 72.879 73.215 67.2679C61.8367 61.6567 59.3987 49.0949 67.7696 39.2103C72.3322 33.8227 79.1642 30.3424 86.2786 29.1994",
    stroke: "#292B2E",
    strokeWidth: 0.549603
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9512 46.5254C91.3706 49.1969 94.5316 50.2907 97.531 49.8536L103.259 43.0897L106.713 44.7929L91.6884 62.534L88.2348 60.8309L94.6734 53.228L94.8664 53C92.9467 52.8806 91.0248 52.3489 89.0883 51.394C87.9441 50.8297 86.7945 50.1167 85.6373 49.2578L79.489 56.5179L76.0367 54.8154L82.7799 46.8528C82.4218 46.5161 82.0626 46.1673 81.7026 45.8026C79.8124 43.8898 76.3491 42.6613 74.548 42.4958L76.0925 39.5126C78.5799 39.8949 82.4149 41.2792 84.7786 43.6718C84.9047 43.7994 85.0302 43.9238 85.1556 44.0475L91.061 37.0743L94.5133 38.7768L88.353 46.051L87.9512 46.5254Z",
    fill: "#292B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolaPoints);
export default __webpack_public_path__ + "static/media/HolaPoints.f60bbfe6a36f73a286993d145e394408.svg";
export { ForwardRef as ReactComponent };